import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Downtime.css";
import Button from "@restart/ui/esm/Button";
import { getDowntimeReasons, queryDB } from "../../../../utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

export const ActionsEntry = (props) => {
  const { downtime, queryParams, fetchStatus, setFetchStatus, setShowModal } = props;
  const [rca, setRca] = useState(downtime['actions'][0]==undefined ? '-':downtime['actions'][0]['rootCauseAnalysis']['description']);
  const [correctiveAct, setCorrectiveAct] = useState(downtime['actions'][0]==undefined ? '-':downtime['actions'][0]['correctivePlan']['description']);
  const [responsibility, setResponsibility] = useState(downtime['actions'][0]==undefined ? '-':downtime['actions'][0]['responsibility']['description']);
  const [targetDate, setTargetDate] = useState(downtime['actions'][0]==undefined ? '-':downtime['actions'][0]['targetDate']['description']);
  const [remarks, setRemarks] = useState(downtime['actions'][0]==undefined ? '-':downtime['actions'][0]['remarks']['description']);
  const initialStartTime = new Date(downtime.startTime);
  const initialEndTime = new Date(downtime.endTime);
  const {startTime,endTime} = downtime;

  const onDeleteClick = async () => {
    if (
      !startTime ||
      !endTime ||
      !queryParams.machineId ||
      queryParams.machineId == ""
    ) {
      alert("incomplete info");
      return;
    }

    let resp = await queryDB(
      {
        doc: {},
        findQuery: {
          machineId: queryParams.machineId,
          startTime: {
            $gte: new Date(initialStartTime),
            $lt: new Date(initialEndTime),
          },
          ignoreUniqueKey: true,
        },
      },
      "actionsentry",
      "delete_many"
    );

    if (resp.status == 200) {
      setFetchStatus(!fetchStatus);
      setShowModal(false);
      toast.warning("REASON DELETED", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error("ERROR OCCURED", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onSaveClick = async () => {
    let actionDoc = {
      lineId: queryParams.lineId,
      plantId: queryParams.plantId,
      machineId: queryParams.machineId,
      startTime: initialStartTime,
      endTime: initialEndTime
    };

    actionDoc.rootCauseAnalysis = {};
    actionDoc.rootCauseAnalysis.description = rca;

    actionDoc.correctivePlan = {};
    actionDoc.correctivePlan.description = correctiveAct

    actionDoc.responsibility = {};
    actionDoc.responsibility.description = responsibility;

    actionDoc.targetDate = {};
    actionDoc.targetDate.description = targetDate;

    actionDoc.remarks = {};
    actionDoc.remarks.description = remarks;

    console.log("actionDoc",actionDoc);
    setShowModal(false);

    let resp = await queryDB(
      {
        doc: actionDoc,
        findQuery: {
          lineId: queryParams.lineId,
          plantId: queryParams.plantId,
          machineId: queryParams.machineId,
          startTime: {
            $gte: new Date(initialStartTime),
            $lt: new Date(initialEndTime),
          },
          ignoreUniqueKey: true,
        },
      },
      "actionsentry",
      "update"
    );

    if (resp.status == 200) {
      setFetchStatus(!fetchStatus);
      toast.success("REASON SAVED", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error("ERROR OCCURED", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  

  return (
    <>
      <textarea
        placeholder={"Root Cause Analysis"}
        id="w3review"
        className="form-control"
        name="w3review"
        rows="4"
        cols="50"
        value={rca}
        onChange={(e) => {
          setRca(e.target.value);
        }}
      ></textarea>
      <br />

      <label>Corrective Action Taken/Planned</label>
      <textarea
        placeholder={"Corrective Action Taken/Planned"}
        id="w3review"
        className="form-control"
        name="w3review"
        rows="4"
        cols="50"
        value={correctiveAct}
        onChange={(e) => {
          setCorrectiveAct(e.target.value);
        }}
      ></textarea>
      <br />

      <label>Responsibility</label>
      <textarea
        placeholder={"Responsibility"}
        id="w3review"
        className="form-control"
        name="w3review"
        rows="4"
        cols="50"
        value={responsibility}
        onChange={(e) => {
          setResponsibility(e.target.value);
        }}
      ></textarea>
      <br />

      <label>Target Date</label>
      <textarea
        placeholder={"Target Date"}
        id="w3review"
        className="form-control"
        name="w3review"
        rows="4"
        cols="50"
        value={targetDate}
        onChange={(e) => {
          setTargetDate(e.target.value);
        }}
      ></textarea>
      <br />

      <label>Remarks</label>
      <textarea
        placeholder={"Remarks"}
        id="w3review"
        className="form-control"
        name="w3review"
        rows="4"
        cols="50"
        value={remarks}
        onChange={(e) => {
          setRemarks(e.target.value);
        }}
      ></textarea>
      <br />
      <div className="text-center">
        <Button className="btn btn-danger" onClick={onDeleteClick}>
          Delete
        </Button>
        &nbsp;&nbsp;
        <Button className="btn btn-primary" onClick={onSaveClick}>
          Save
        </Button>
      </div>
    </>
  );
};
